// getters
export const IS_SIGN_LANGUAGE_ENABLED = 'user/IS_SIGN_LANGUAGE_ENABLED'
// mutations
export const ENABLE_SIGN_LANGUAGE = 'user/ENABLE_SIGN_LANGUAGE'
export const DISABLE_SIGN_LANGUAGE = 'user/DISABLE_SIGN_LANGUAGE'
export const SET_SIGN_LANGUAGE_ENABLED = 'user/SET_SIGN_LANGUAGE_ENABLED'
